export const SPECIAL_FOLDERS: Record<string, string> = {
  "user-slides": "My slides",
  "team-slides": "Team slides",
};
